//销毁查询
import React from 'react'
import Manager from 'Tyan/public/components/Manager'
import DocumentDestructionDiv from './DocumentDestructionDiv'

Ext.require('Ext.Toast')

const config = {
    export: true,
    buttons: [
    ],
    columns: [
        { _text: '文件编号', field: 'QualityFileNumber', minWidth: 250, search: true, },
        { _text: '文件名称', field: 'QualityFileName', minWidth: 350, search: true, },
        { _text: '版别', field: 'Version', minWidth: 150, },
        { _text: '所属目录', field: 'QualityFileDirectory', minWidth: 150, },
        { _text: '起草人', field: 'DraftOutPerson', minWidth: 150, },
        { _date: '起草日期', field: 'DraftOutDate', minWidth: 150, },
        { _text: '审核人', field: 'Auditor', minWidth: 150, },
        { _date: '审核日期', field: 'AuditTime', minWidth: 150, },
        { _text: '批准人', field: 'Approver', minWidth: 150, },
        { _date: '批准日期', field: 'ApprovalTime', minWidth: 150, },
        { _text: '状态名称', field: 'StatusName', minWidth: 150, filter: true, },

    ],
    onDoubleTap: ({ showDetail, refreshPage }, data, record) => {
        Tyan.pubForm.showDialog('文件销毁', props => <DocumentDestructionDiv {...props} id={data.id} onFlowFinished={refreshPage} onSave={refreshPage} />)
    },
}

export default props => <Manager {...props} config={config} />